export const shareWebUrl = 'https://yanshi.smrwl.com/website/';
export const uploadUrl = 'https://yanshi.smrwl.com/website/';
export const baseServerUrl = 'https://yanshi.smrwl.com/website/';
